import * as IF from "infrontjs";

import { IndexState } from "../state/IndexState.js";
import { StateManager } from "./StateManager.js";
import { Lyte } from "./Lyte.js";

export class App extends IF.App
{
    constructor()
    {
        super( document.getElementById( 'app' ) );
        this.stateManager = new StateManager( this );
        this.lyte = new Lyte();
    }

    async run( route = null )
    {
        this.init();
        await super.run( route );
    }

    init()
    {
        this.stateManager.add( IndexState );
    }
}
